import type { CDEKCity } from '@entities/cart/model/types.ts';
import { createApi } from '@reduxjs/toolkit/query/react';
import { getRtkConfig } from '@shared/config/index.ts';

export const deliveryApi = createApi({
  reducerPath: 'deliveryApi',
  baseQuery: getRtkConfig('/api/v1/delivery'),
  tagTypes: [],
  keepUnusedDataFor: Number.MAX_SAFE_INTEGER,
  endpoints: (build) => ({
    getCityByCode: build.query<CDEKCity, number>({
      query: (city_code) => ({
        url: `cdek/city/get_city/?code=${city_code}`,
        method: 'GET',
      }),
    }),
  }),
});
export const { useGetCityByCodeQuery } = deliveryApi;
export const deliveryApiReducer = deliveryApi.reducer;
export const deliveryApiPath = deliveryApi.reducerPath;
export const deliveryApiMiddleware = deliveryApi.middleware;
